// TransactioinUploader styles
// src/components/TransactionUploader/TransactionUploader.styles.ts

import styled, { keyframes, css } from 'styled-components';

export const Container = styled.div`
  padding: var(--space-3);
  padding: 16px;
`;

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;


export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: var(--shadow);
  border-radius: var(--border-radius);
  overflow: hidden;
`;

export const Th = styled.th`
  padding: var(--space-2);
  border-bottom: 1px solid var(--gray-300);
  text-align: left;
`;

export const Td = styled.td`
  padding: var(--space-2);
  border-bottom: 1px solid var(--gray-300);
`;

export const ActionButton = styled.button<{ disabled?: boolean }>`
  background-color: ${({ disabled }) =>
    disabled ? 'var(--gray-200)' : 'var(--color-primary)'};
  color: ${({ disabled }) => (disabled ? 'var(--gray-500)' : '#fff')};
  padding: var(--space-2) var(--space-3);
  border: none;
  border-radius: var(--border-radius);
  margin-right: var(--space-3);
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  box-shadow: var(--shadow);
  transition: background-color 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    ${({ disabled }) =>
    !disabled &&
    `
      background-color: var(--color-accent);
      transform: translateY(-2px);
      box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
    `}
  }

  &:focus {
    outline: 2px solid var(--color-secondary);
    outline-offset: 2px;
  }
`;

export const Wrapper = styled.div`
  margin-bottom: var(--space-3);
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const Label = styled.label`
  display: inline-block;
  background-color: var(--color-primary);
  color: #fff;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--border-radius);
  cursor: pointer;
  margin-right: var(--space-3);

  &:focus {
    outline: 2px solid var(--color-secondary);
    outline-offset: 2px;
  }
`;

export const FileName = styled.span`
  font-style: italic;
`;

export const ErrorText = styled.div`
  color: var(--color-error);
  margin-top: var(--space-2);
`;


export const Alert = styled.div`
  color: var(--color-error);
  margin-top: var(--space-2);
`;


// 1. Define the animation: slide the gradient back and forth
const rainbowShift = keyframes`
  0%   { background-position: 0%   50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0%   50%; }
`;

export const Tr = styled.tr<{ disabled?: boolean; isAnimating?: boolean }>`
  /* Keep your disabled styling */
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.4;
      pointer-events: none;
    `}
  
  ${({ isAnimating }) =>
    isAnimating &&
    css`
      background: linear-gradient(
        270deg,
        #ff0000 0%,   /* red */
        #ff7f00 15%,  /* orange */
        #ffff00 30%,  /* yellow */
        #00ff00 45%,  /* green */
        #0000ff 60%,  /* blue */
        #4b0082 75%,  /* indigo */
        #8f00ff 90%   /* violet */
      );
      background-size: 400% 400%;
      animation: ${rainbowShift} 6s ease infinite;
    `}


`;


export const ScrollWrapper = styled.div`
  overflow-x: auto;
  overflow-y: visible;
  width: 100%;
`;

// Wrapper for the nested table
export const InnerTable = styled.table<{ isAnimating?: boolean }>`
  width: 100%;
  border-collapse: collapse;
  background-color: var(--gray-100);
  box-shadow: var(--shadow);
  border-radius: var(--border-radius);

  margin-bottom: 50px;
  table-layout: fixed;

  thead th {
    padding: var(--space-2);
    text-align: left;
    font-weight: 600;
    border-bottom: 1px solid var(--gray-300);
  }

  tbody td {
    padding: var(--space-2);
    border-bottom: 1px solid var(--gray-300);
    vertical-align: top;
    min-height: 40px;
  }

  tr:nth-child(even) {
    background-color: var(--gray-050);
  }

  ${({ isAnimating }) =>
    isAnimating &&
    css`
      background: linear-gradient(
        270deg,
        #ff0000 0%,
        #ff7f00 15%,
        #ffff00 30%,
        #00ff00 45%,
        #0000ff 60%,
        #4b0082 75%,
        #8f00ff 90%
      );
      background-size: 400% 400%;
      animation: ${rainbowShift} 6s ease infinite;
    `}
`;

export const Input = styled.input`
  width: 100%;
  padding: 4px 8px;
  font: inherit;
  height: 32px;
  box-sizing: border-box;
  border: 1px solid var(--gray-300);
  border-radius: var(--border-radius);
`;

export const Select = styled.select`
  width: 100%;
  padding: 4px 8px;
  font: inherit;
  height: 32px;
  box-sizing: border-box;
  border: 1px solid var(--gray-300);
  border-radius: var(--border-radius);
`;
